import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QmsFolder } from "../../pages/dashboard/qms-elements/other-qms-elements/interface";

interface FolderStructureState {
  currentFolderId: string | null;
  parentFolderId: string | null;
  currentLevel: number;
  folders: QmsFolder[];
  loading: boolean;
  error: string | null;
  meta: {
    totalCount: number;
    count: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const initialState: FolderStructureState = {
  currentFolderId: null,
  parentFolderId: null,
  currentLevel: 1,
  folders: [],
  loading: false,
  error: null,
  meta: {
    totalCount: 0,
    count: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  },
};

const qmsFolderStructureSlice = createSlice({
  name: "qmsFolderStructure",
  initialState,
  reducers: {
    fetchFolders: (
      state,
      action: PayloadAction<{
        elementId: string;
        parentFolderId?: string;
        folderType?: string;
        status?: string;
      }>,
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchFoldersSuccess: (
      state,
      action: PayloadAction<{
        folders: any;
        meta: FolderStructureState["meta"];
        parentFolderId: string | null;
      }>,
    ) => {
      state.folders = action.payload.folders;
      state.meta = action.payload.meta;
      state.parentFolderId = action.payload.parentFolderId;
      state.loading = false;
      state.error = null;
    },
    fetchFoldersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCurrentFolder: (
      state,
      action: PayloadAction<{ folderId: string | null; level: number }>,
    ) => {
      state.currentFolderId = action.payload.folderId;
      state.currentLevel = action.payload.level;
      // Save to localStorage for persistence
      if (action.payload.folderId) {
        localStorage.setItem("currentFolderId", action.payload.folderId);
        if (action.payload.level !== undefined) {
          localStorage.setItem(
            "currentFolderLevel",
            action.payload.level.toString(),
          );
        }
      } else {
        localStorage.removeItem("currentFolderId");
        localStorage.removeItem("currentFolderLevel");
      }
    },
    resetFolderStructure: (state) => {
      return initialState;
    },
  },
});

export const {
  fetchFolders,
  fetchFoldersSuccess,
  fetchFoldersFailure,
  setCurrentFolder,
  resetFolderStructure,
} = qmsFolderStructureSlice.actions;

export default qmsFolderStructureSlice.reducer;
